import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppVersionService } from '../../services/app-version.service';
import { AppUpdaterService } from '../../services/app-updater.service';

@Component({
    standalone: true,
    selector: 'app-footer',
    imports: [CommonModule],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    readonly versionSvc = inject(AppVersionService);
    readonly updater = inject(AppUpdaterService);

    async ngOnInit(): Promise<void> {
        this.updater.init();
        if (!this.versionSvc.loaded()) {
            await this.versionSvc.load();
        }
    }

    get envSuffix(): string {
        const env = this.versionSvc.env();
        return env && env !== 'prod' && env !== 'web' ? ` · ${env}` : '';
    }

    onDownload(): void { this.updater.downloadUpdate(); }
    onInstall(): void { this.updater.installNow(); }
}
